export function parseJsonWithReferences(jsonString) {
    const objectMap = new Map();

    function resolveReferences(obj) {
        if (typeof obj === 'object' && obj !== null) {
            if (obj.$ref) {
                return objectMap.get(obj.$ref);
            }
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    obj[key] = resolveReferences(obj[key]);
                }
            }
            // Remove $id property if it exists
            delete obj.$id;
        }
        return obj;
    }

    function parseWithReferences(jsonString) {
        const parsed = JSON.parse(jsonString, function (key, value) {
            if (value && typeof value === 'object' && value.$id) {
                objectMap.set(value.$id, value);
            }
            return value;
        });
        const resolved = resolveReferences(parsed);
        let result = resolved;
        if (objectMap.size > 0) {
            // Return the first child of the resolved object
            const firstKey = Object.keys(resolved)[0];
            const firstChild = resolved[firstKey];
            if (Array.isArray(firstChild)) {
                result = firstChild;
            }
        }

        return result;
    }

    return parseWithReferences(jsonString);
}
